exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._4c82k6sc54cerhtfk6kgttvvbm8yvaz9kjkxvh3kug9c38qhwrhqx5fb9shd7ryytsuh5yhn12pnkpqdbcae8ykwwsjjsrk19pqdyk9-HeadMessage-module-head-message{padding:0}", "", {"version":3,"sources":["C:/a/_work/5/s/src/views/SentRequestsReview/components/HeadMessage/C:/a/_work/5/s/src/views/SentRequestsReview/components/HeadMessage/HeadMessage.module.scss"],"names":[],"mappings":"AAAA,0IACE,SAAkB,CACnB","file":"HeadMessage.module.scss","sourcesContent":[".head-message {\r\n  padding: 0 0 0px 0;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"head-message": "_4c82k6sc54cerhtfk6kgttvvbm8yvaz9kjkxvh3kug9c38qhwrhqx5fb9shd7ryytsuh5yhn12pnkpqdbcae8ykwwsjjsrk19pqdyk9-HeadMessage-module-head-message"
};